"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Textarea = exports.TextInputField = exports.Input = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formik = require("formik");
var _transparentize = _interopRequireDefault(require("polished/lib/color/transparentize"));
var _react = _interopRequireDefault(require("react"));
var _reactAutosizeTextarea = _interopRequireDefault(require("react-autosize-textarea"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _theme = require("../../constants/theme");
var _Body = _interopRequireDefault(require("../primitive/Body"));
var _excluded = ["error", "rows", "type", "variant", "displayTouched", "children", "iconClickHandler", "hideErrorMessage", "maxLength"],
  _excluded2 = ["name", "displayTouched"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// need to take out all props that conflict with InputProps

var TextInput = _react["default"].forwardRef(function (_ref, ref) {
  var error = _ref.error,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 3 : _ref$rows,
    type = _ref.type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'medium' : _ref$variant,
    displayTouched = _ref.displayTouched,
    children = _ref.children,
    iconClickHandler = _ref.iconClickHandler,
    hideErrorMessage = _ref.hideErrorMessage,
    maxLength = _ref.maxLength,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var inputProps = {
    error: error,
    variant: variant,
    type: type
  };
  return /*#__PURE__*/_react["default"].createElement(Container, null, children && /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    onClick: iconClickHandler
  }, children), type === 'textarea' ? /*#__PURE__*/_react["default"].createElement(Textarea, Object.assign({
    rows: rows,
    ref: ref
  }, inputProps, props)) : /*#__PURE__*/_react["default"].createElement(Input, Object.assign({
    withIcon: !!children,
    ref: ref,
    displayTouched: displayTouched,
    maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : 255
  }, inputProps, props)), maxLength && type === 'textarea' && /*#__PURE__*/_react["default"].createElement(CharactersCounter, {
    variant: "small",
    error: props.value.length > maxLength
  }, "".concat(maxLength - (props.value || '').length, "/").concat(maxLength)), error && !hideErrorMessage && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], null, error));
});
var TextInputField = exports.TextInputField = _react["default"].forwardRef(function (_ref2, ref) {
  var name = _ref2.name,
    _ref2$displayTouched = _ref2.displayTouched,
    displayTouched = _ref2$displayTouched === void 0 ? false : _ref2$displayTouched,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, Object.assign({
    name: name
  }, props), function (_ref3) {
    var field = _ref3.field,
      _ref3$form = _ref3.form,
      errors = _ref3$form.errors,
      touched = _ref3$form.touched,
      values = _ref3$form.values;
    return /*#__PURE__*/_react["default"].createElement(TextInput, Object.assign({
      ref: ref,
      displayTouched: displayTouched && (0, _formik.getIn)(values, field.name),
      error: (0, _formik.getIn)(touched, field.name) && (0, _formik.getIn)(errors, field.name) ? (0, _formik.getIn)(errors, field.name) : undefined
    }, field, props));
  });
});
var _default = exports["default"] = TextInput;
var CharactersCounter = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  displayName: "TextInput__CharactersCounter",
  componentId: "sc-1ghb0xv-0"
})(["position:absolute;right:", ";bottom:", ";color:", ";pointer-events:none;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing['40_Standard'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing['40_Standard'];
}, function (_ref6) {
  var theme = _ref6.theme,
    error = _ref6.error;
  return error ? theme.colors.negative['50'] : theme.colors.neutral['50'];
});
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TextInput__IconWrapper",
  componentId: "sc-1ghb0xv-1"
})(["position:absolute;height:100%;display:flex;align-items:center;left:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing['40_Standard'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['30'];
});
var inputCss = (0, _styledComponents.css)(["width:100%;background-color:", ";padding:", ";margin-bottom:", ";@media (max-width:", "){padding:0.6rem 1.2rem;}outline:none;border:none;border-radius:", ";letter-spacing:0.15px;--border-color:", ";box-shadow:0 0 0 1px var(--border-color),inset 0 0 0 1px var(--border-color);-webkit-appearance:none;", "::placeholder{color:", ";}:focus{--border-color:", ";}:disabled{background:", ";cursor:not-allowed;opacity:1;}:hover:not(:focus){--border-color:", ";}"], function (_ref9) {
  var theme = _ref9.theme,
    displayTouched = _ref9.displayTouched;
  return displayTouched ? (0, _transparentize["default"])(0.9, theme.colors.primary['40']) : theme.colors.neutral['0'];
}, function (_ref10) {
  var variant = _ref10.variant,
    type = _ref10.type,
    theme = _ref10.theme;
  var radius = type === 'textarea' ? theme.radius.textArea : theme.radius.textInput;
  return variant === 'small' ? "0.6rem max(1.2rem, ".concat(radius, ")") : "1.2rem max(1.6rem, ".concat(radius, ")");
}, function (_ref11) {
  var error = _ref11.error;
  return error ? '4px' : '0';
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.mediaQueries.s;
}, function (_ref13) {
  var type = _ref13.type,
    theme = _ref13.theme;
  return type === 'textarea' ? theme.radius.textArea : theme.radius.textInput;
}, function (_ref14) {
  var error = _ref14.error,
    displayTouched = _ref14.displayTouched,
    theme = _ref14.theme;
  return error ? "".concat(theme.colors.negative['60'], " !important") : displayTouched ? "".concat(theme.colors.primary['40'], " !important") : theme.colors.neutral['20'];
}, function (_ref15) {
  var error = _ref15.error;
  return error && 'z-index: 1;';
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.neutral['40'];
}, function (_ref17) {
  var theme = _ref17.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.neutral['10'];
}, function (_ref19) {
  var theme = _ref19.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input);
});
var Textarea = exports.Textarea = (0, _styledComponents["default"])(_reactAutosizeTextarea["default"]).withConfig({
  displayName: "TextInput__Textarea",
  componentId: "sc-1ghb0xv-2"
})(["resize:vertical !important;min-height:4.8rem;", ";"], inputCss);
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "TextInput__Input",
  componentId: "sc-1ghb0xv-3"
})(["", " ", ""], inputCss, function (_ref20) {
  var withIcon = _ref20.withIcon;
  return withIcon ? 'padding-left: 5rem !important;' : '';
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "TextInput__Container",
  componentId: "sc-1ghb0xv-4"
})(["position:relative;flex:1;"]);
//# sourceMappingURL=TextInput.js.map